module.exports = __webpack_public_path__ + "img/btn_bg.8cb2ac79.png";